import { defineStore } from 'pinia';
import { useGlobalStore } from '@/store/global-store-base';
import { useApi } from '@lib/api';

export const useSampleStatuses = defineStore('sample-statuses', () => {
  const api = useApi();
  const globalStoreBase = useGlobalStore({
    load: api.sampleStatus_ListSampleStatuses,
    dto: 'SampleStatusDto',
    create: api.sampleStatus_CreateSampleStatus,
    update: api.sampleStatus_UpdateSampleStatus,
    delete: api.sampleStatus_DeleteSampleStatus,
    usage: api.sampleStatus_GetUsage,
    signalR: 'SampleStatusUpdate',
  });

  return {
    ...globalStoreBase,
  };
});
